<template>
	<div class="recharge-page  ">
		<div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('trade.label60') }} </div>

	
		<div class="recharge-main ">
			<div class="page-form">
				<div class="form-item"> 
					<div class="label">{{i18n.t('transfer.label1')}}</div>
					<div class="input">
						<a-select v-model="form.fromAccount" @change="chooseFromAccount"  dropdownClassName="full-select" class="hide-border" :placeholder="$t('qing-xuan-ze-0')">
              <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
              <a-select-option v-for="(option, index) in accountList" :key="index" :value="option.key" >
                {{option.name}}
              </a-select-option>
            </a-select>
					</div>
				</div>

				<div class="img-line flex-center" @click="rechange">
					<img :src="transferUrl" alt="">
				</div>

				<div class="form-item"> 
					<div class="label">{{i18n.t('transfer.label2')}}</div>
					<div class="input">
						<a-select v-model="form.toAccount"  dropdownClassName="full-select" class="hide-border" :placeholder="$t('qing-xuan-ze-1')">
              <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
              <a-select-option v-for="(option, index) in accountList" :key="index" :value="option.key" :disabled="option.key == form.fromAccount">
                {{option.name}}
              </a-select-option>
            </a-select>
					</div>
				</div>

				<div class="form-item">
					<div class="label">{{i18n.t('transfer.label4')}}</div>
					<div class="input">
						<input type="text"  v-model="form.money" :placeholder="i18n.t('transfer.labelPlaceholder')">
						<div class="adot long" @click="setAll">
							{{i18n.t('transfer.label5')}}
						</div>
					</div>
					<div class="desc-line flex-center-start">
						<div>{{i18n.t('transfer.label6')}}： </div>
						<div class="count"> {{resetMoney(userMoney)}} USDT</div>
					</div>
				</div>
				
				<div class="btn">
					<Button  @click="submit">{{i18n.t('transfer.btn')}}</Button>
				</div>
			</div>
		</div>

		<div class="space-line"></div>

		<div class="page-title">{{ $t('quan-bu-hua-zhuan-ji-lu') }}</div>

		<div class="list-table clear-bg">
      <div class="th-line flex-center-between">
        <div class="th flex-2">{{ $t('transfer.label3') }}</div>
        <div class="th flex-2">{{ $t('chart_page.time') }}</div>
        <div class="th flex-2">{{ $t('transfer.label1') }}</div>
        <div class="th flex-2">{{ $t('dao') }}</div>
        <div class="th flex-2">{{ $t('transfer.label4') }}</div>
        <div class="th action">{{ $t('finance.label12') }}</div>
      </div>
      <div class="tbody">
        <div class="td-line flex-center-between" v-for="(item, i) in logList" :key="i" >
          <div class="td flex-2 flex-center-start">
            <img :src="'/upload/' + (item.Currency ? item.Currency.Logo : '')" alt="">
            <span>{{item.Currency ? item.Currency.ShortName : ''}}</span>
          </div>
          <div class="td flex-2">{{item.CreatedAt || item.created_at}}</div>
          <div class="td flex-2">{{getAccountName(item.FromAccount || item.from_account)}}</div>
          <div class="td flex-2">{{getAccountName(item.ToAccount || item.to_account)}}</div>
          <div class="td flex-2">{{formatAmountDisplay(item.Amount || item.Practical)}}</div>
          <div class="td action flex-center">
						<span class="point"></span>
            {{i18n.t('transfer.success')}}
          </div>
        </div>
      </div>
    </div>

    <pageBar :total="page.total" @changePage="changePage"></pageBar>
	</div>
</template>
<script>
import { debtType, debtLog, transferRecordLists } from '@/api/assest'
import { Popup, Button } from 'vant'
import {formatNumber, formatAmount} from '@/utils/common'
import { getCoinList } from '@/api/index'
import { wallet, transfer } from '@/api/assest'
import pageBar from '@/components/pageBar'
export default {
	components: {
    Popup,
    Button,
		pageBar
  },
  data() {
		return {
			form: {
				money: '',
				fromAccount: '',
				toAccount: '',
			},
			userMoney: 0,
			closeUrl: require('../../assets/imgs/icon-close.png'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			transferUrl: require('../../assets/imgs/icon-transfer2.png'),
			downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
			showRecharge: false,
			inputActive: false,
      bitIndex: 0,
			bitInfo: {},
			accountList: [
				{
					name: this.i18n.t('transfer.account1'),
					key: 'Capital',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account2'),
					key: 'Spot',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account3'),
					key: 'Contract',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account4'),
					key: 'Option',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account5'),
					key: 'Finance',
					count: 0
				},
				{
					name: this.i18n.t('transfer.account6'),
					key: 'Follow',
					count: 0
				},
			],
			fromIndex: 0,
			toAccount: {},
			showToAccount: false,
			page: {
				page: 1,
				limit: 10,
				total: 1
			},
			logList: [],
			formBak: ''
		}
	},
	computed: {
		bitList() {
      return this.$store.state.bitList
    }
	},
  mounted() {
		let type = this.$route.query.type
		if (type == 1) {// 资产进入划转, 显示资产到期权
			this.form.fromAccount = this.accountList[0].key
			this.form.toAccount = this.accountList[3].key
		} else if (type == 2) {// 期权进入划转, 显示期权到资产
			this.fromIndex = 3
			this.form.fromAccount = this.accountList[3].key
			this.form.toAccount = this.accountList[0].key
		} else if (type == 3) {// 合约进入划转, 显示合约到资产
			this.fromIndex = 2
			this.form.fromAccount = this.accountList[2].key
			this.form.toAccount = this.accountList[0].key
		} else if (type == 4) {// 现货进入划转, 显示现货到资产
			this.fromIndex = 1
			this.form.fromAccount = this.accountList[1].key
			this.form.toAccount = this.accountList[0].key
		} else if (type == 5) {// 金融进入划转, 显示金融到资产
			this.fromIndex = 4
			this.form.fromAccount = this.accountList[4].key
			this.form.toAccount = this.accountList[0].key
		} else if (type == 6) {// 跟单进入划转, 显示跟单到资产
			this.fromIndex = 5
			this.form.fromAccount = this.accountList[5].key
			this.form.toAccount = this.accountList[0].key
		} else {
			this.form.fromAccount = this.accountList[0].key
			this.form.toAccount = this.accountList[1].key
		}
		this.formBak = this.form.fromAccount
		this.init()
		this.initLog()

		// 开发环境下测试格式化函数
		if (process.env.NODE_ENV === 'development') {
			this.testFormatAmount()
		}
  },
	methods: {
		init() {
			let list = localStorage.getItem('bitList')
      if (list && list != 'undefined' && this.bitList.length == 0) {
        this.$store.state.bitList = JSON.parse(list)
      } 
			if (this.bitList.length == 0) {
        getCoinList().then(res => {
          let bitList = res.data.Items
          this.$store.state.bitList = [].concat(bitList)
					this.getWallet()
        })
      } else {
				this.getWallet()
			}
    },
		changePage(page) {
      this.page.page = page
      this.initLog()
    },
		initLog() {
			// 使用新的划转记录接口
			let form = new FormData()
			form.append('current', this.page.page)
      form.append('limit', this.page.limit)
      form.append('CurrencyId', '')
      form.append('FromAccount', '')
      form.append('ToAccount', '')
      transferRecordLists(form).then(res => {
				this.logList = res.data.Items
				this.page.total = res.data.Pagination.totalRecords
			}).catch(err => {
				// 如果新接口失败，回退到旧接口
				console.warn('新划转记录接口失败，使用旧接口:', err)
				let fallbackForm = new FormData()
				fallbackForm.append('current', this.page.page)
				fallbackForm.append('pageSize', this.page.limit)
				fallbackForm.append('CurrencyType', '')
				fallbackForm.append('Type', '')
				fallbackForm.append('MultiType', '2,3')
				fallbackForm.append('CurrencyId', '')
				debtLog(fallbackForm).then(res => {
					this.logList = res.data.Items
					this.page.total = res.data.Pagination.totalRecords
				})
			})
		},

		getWallet() {
			let form = new FormData()
      form.append('ShortName', 'usdt')
      form.append('current', 1)
      form.append('pageSize', 10)
      wallet(form).then(res => {
				let data = res.data.Items[0]
				if (data) {
					// 验证返回的币种是否为USDT
					if (data.Currency && data.Currency.ShortName.toLowerCase() === 'usdt') {
						// 直接使用返回的Currency对象作为bitInfo
						this.bitInfo = data.Currency
						
						// 直接使用字符串保持原始精度，避免 parseFloat() 精度丢失
						this.accountList[0].count = data.CapitalUse
						this.accountList[1].count = data.SpotUse
						this.accountList[2].count = data.ContractUse
						this.accountList[3].count = data.OptionUse
						this.accountList[4].count = data.FinanceUse
						this.accountList[5].count = data.FollowUse || '0'

						let index = this.accountList.findIndex(v => {
							return v.key == this.form.fromAccount
						})

						// 使用原始字符串数据，保持最高精度
						this.userMoney = this.accountList[index].count
					} else {
						// 没有找到USDT记录，初始化为0
						console.warn('未找到USDT钱包记录，返回的币种为:', data.Currency ? data.Currency.ShortName : 'unknown')
						this.bitInfo = null
						this.accountList.forEach(account => {
							account.count = '0.00000000'
						})
						this.userMoney = '0.00000000'
					}
				} else {
					// 没有任何记录，初始化为0
					this.bitInfo = null
					this.accountList.forEach(account => {
						account.count = '0.00000000'
					})
					this.userMoney = '0.00000000'
				}
      })
		},
		back() {
			this.$router.go(-1)
		},
		chooseFromAccount(e) {
			if (e == this.form.toAccount) {
				this.form.toAccount = this.formBak
			}
			let index = this.accountList.findIndex(v => {
				return v.key == this.form.fromAccount
			})
			// 直接使用原始数据，避免精度丢失
			this.userMoney = this.accountList[index].count
			this.formBak = this.form.fromAccount
		},
		setAll() {
			this.form.money = this.userMoney
		},
		submit() {
			if (!this.form.money) {
				this.$toast.fail(this.i18n.t('transfer.labelPlaceholder'))
				return
			}

			if (!this.bitInfo || !this.bitInfo.ID) {
				// this.$toast.fail('系统配置错误：币种信息无效')
				return
			}

			let form = new FormData()
			form.append('From', this.form.fromAccount)
			form.append('To', this.form.toAccount)
			form.append('Amount', this.form.money)
			form.append('CurrencyId', this.bitInfo.ID)
			transfer(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('transfer.success'))
					this.form.money = ''
					// 更新钱包余额
					this.getWallet()
					// 刷新划转记录
					this.initLog()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		rechange() {
			let bak = this.form.fromAccount
			this.form.fromAccount = this.form.toAccount
			this.form.toAccount = bak
			let index = this.accountList.findIndex(v => {
				return v.key == this.form.fromAccount
			})
			// 直接使用原始数据，避免精度丢失
			this.userMoney = this.accountList[index].count
		},
		resetMoney(money) {
			// 使用智能格式化函数
			return formatAmount(money)
		},
		// 获取账户类型的显示名称
		getAccountName(accountType) {
			const accountMap = {
				'Capital': this.i18n.t('transfer.account1'),
				'Spot': this.i18n.t('transfer.account2'),
				'Contract': this.i18n.t('transfer.account3'),
				'Option': this.i18n.t('transfer.account4'),
				'Finance': this.i18n.t('transfer.account5'),
				'Follow': this.i18n.t('transfer.account6')
			}
			return accountMap[accountType] || accountType
		},
		// 格式化金额显示 - 包装utils中的formatAmount函数
		formatAmountDisplay(amount) {
			return formatAmount(amount)
		},


		// 测试格式化函数（开发时使用，生产环境可删除）
		testFormatAmount() {
			const testCases = [
				'0.00001',
				'0.00001000',
				'0.1234',
				'0.12340000',
				'1.2345',
				'1.23456789',
				'0.00000001',
				'0.00000100',
				'123.456',
				'0',
				'1',
				'0.0000',
				'0.00000000'
			]

			console.log('=== 格式化测试结果 ===')
			testCases.forEach(testCase => {
				const result = formatAmount(testCase)
				console.log(`${testCase} -> ${result}`)
			})
		}
	}
}
</script>